if (!customElements.get("ctl-product-info")) {
  class CTLProductInfo extends HTMLElement {
    constructor() {
      super();
      this.onVariantChangeUnsubscriber = undefined;
    }

    get productId() {
      return this.getAttribute('data-product-id');
    }

    get sectionId() {
      return this.dataset.sectionId;
    }

    get productForm() {
      return this.querySelector('product-form');
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.onVariantChangeUnsubscriber?.();
    }

    init() {
      const variantsJson = this.querySelector(`[id^="VariantsJson-"]`);
      if (!variantsJson) return;
      this.variantData = JSON.parse(variantsJson.textContent);
      
      this.onVariantChangeUnsubscriber = MinimogEvents.subscribe(
        MinimogTheme.pubSubEvents.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this)
      );

      // Initial state
      this.updateUI();
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      if (!this.contains(event.target)) return;
      this.updateUI();
    }

    updateUI() {
      const variant = this.getSelectedVariant();
      this.updatePrice(variant);
      this.updateForm(variant);
      this.updateAddToCartButton(variant);
      this.updateLabels();
    }

    getSelectedVariant() {
      const options = Array.from(this.querySelectorAll('.m-product-option__input:checked, .m-product-option select'));
      const selectedValues = options.map(el => el.value);
      
      return this.variantData.find(v => {
        return v.options.every((optValue, index) => optValue === selectedValues[index]);
      });
    }

    updatePrice(variant) {
      const priceContainer = this.querySelector(`#Price-${this.sectionId}`);
      if (!priceContainer) return;

      if (!variant) {
        priceContainer.classList.add('m:hidden');
        return;
      }
      priceContainer.classList.remove('m:hidden');

      const regularPrice = priceContainer.querySelector('.m-price-item--regular');
      const salePrice = priceContainer.querySelector('.m-price-item--sale');
      
      const moneyFormat = window.MinimogSettings.money_format || "${{amount}}";

      if (regularPrice) {
        regularPrice.textContent = this.formatMoney(variant.compare_at_price || variant.price, moneyFormat);
      }
      if (salePrice) {
        salePrice.textContent = this.formatMoney(variant.price, moneyFormat);
      }
      
      priceContainer.classList.toggle('m-price--on-sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
      priceContainer.classList.toggle('m-price--sold-out', !variant.available);
    }

    updateForm(variant) {
      // CRITICAL: Target the input INSIDE the form
      const productForm = this.querySelector('product-form form');
      if (productForm) {
        const inputId = productForm.querySelector('input[name="id"]');
        if (inputId) {
          inputId.value = variant ? variant.id : '';
          inputId.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    updateAddToCartButton(variant) {
      const productForm = this.querySelector('product-form');
      if (!productForm) return;
      
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('.m-add-to-cart--text');
      
      if (!addButton || !addButtonText) return;

      if (!variant) {
        addButton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = window.MinimogStrings.unavailable || 'Unavailable';
      } else if (!variant.available) {
        addButton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = window.MinimogStrings.soldOut || 'Sold Out';
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.MinimogStrings.addToCart || 'Add to cart';
      }
    }

    updateLabels() {
      this.querySelectorAll('.m-product-option').forEach(optionEl => {
        const input = optionEl.querySelector('.m-product-option__input:checked, select');
        const labelSelected = optionEl.querySelector('.option-label--selected');
        if (input && labelSelected) {
          labelSelected.textContent = input.value;
        }
      });
    }

    formatMoney(cents, format) {
       if (window.formatMoney) return window.formatMoney(cents, format);
       let value = (cents / 100).toFixed(2);
       return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
    }
  }

  customElements.define("ctl-product-info", CTLProductInfo);
}
